import { render, staticRenderFns } from "./TMSReportMenu.vue?vue&type=template&id=5538c5be&scoped=true&"
import script from "./TMSReportMenu.vue?vue&type=script&lang=js&"
export * from "./TMSReportMenu.vue?vue&type=script&lang=js&"
import style0 from "./TMSReportMenu.vue?vue&type=style&index=0&id=5538c5be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5538c5be",
  null
  
)

export default component.exports